import type { CSSProperties } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Ic from "../icons.jsx";

/**
 * Tabla|lista tabs for Lidovi — the OffersViewSwitcher idiom. Board and list
 * live on separate routes (/leads, /leads/list); the search text is the one
 * filter criterion carried across via the `q` URL param so switching views
 * doesn't lose what the user typed.
 */
export function LeadsViewSwitcher({ active, search }: { active: "board" | "list"; search: string }) {
  const { t } = useTranslation();
  const qs = search ? `?q=${encodeURIComponent(search)}` : "";
  return (
    <div style={row}>
      <Link
        to={`/leads${qs}`}
        className={active === "board" ? "btn primary sm" : "btn sm"}
        style={active !== "board" ? { textDecoration: "none" } : undefined}
      >
        <Ic.grid /> {t("leads.view.board", "Board")}
      </Link>
      <Link
        to={`/leads/list${qs}`}
        className={active === "list" ? "btn primary sm" : "btn sm"}
        style={active !== "list" ? { textDecoration: "none" } : undefined}
      >
        <Ic.list /> {t("leads.view.list", "List")}
      </Link>
    </div>
  );
}

const row: CSSProperties = { display: "flex", gap: 6 };
